import React from 'react';
import { TextButton } from '@oneaudi/unified-web-components';
import type { VendorCtaSelectorProps } from './VendorCtaSelector';

const RoadsterCta = ({ ctaDetails, variant, vin }: VendorCtaSelectorProps) => {
  return (
    <TextButton
      className="roadster-btn"
      variant={variant}
      href={`${ctaDetails.ctaRoadsterUrl}${vin}`}
      data-testid="roadster"
    >
      {ctaDetails.actionTypeRoadster}
    </TextButton>
  );
};

export default RoadsterCta;
